

























































































































































import Vue, { PropType } from "vue";
import SpeechBubble from "@/components/Atoms/SpeechBubble/index.vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import NumberText from "@/components/Atoms/Typography/Number/index.vue";
import Suffix from "@/components/Atoms/Typography/Suffix/index.vue";
import Body from "@/components/Atoms/Typography/Body/index.vue";
import ButtonConfig from "@/components/Molecules/ButtonConfig/index.vue";
import Button from "@/components/Atoms/Button/index.vue";
import EventHeader from "@/components/Molecules/EventHeader/index.vue";
import { Data, Methods, Computed, Props } from "./types";
import { BME_PART, EventCategory, EventPurpose } from "@/api/types";
import { KEYCODE } from "@/constants/event";

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    SpeechBubble,
    Heading,
    NumberText,
    Suffix,
    Body,
    Button,
    ButtonConfig,
    EventHeader
  },
  props: {
    planGraduateYear: {
      type: Number,
      required: true
    },
    selectedEvent: {
      type: Object as PropType<Props["selectedEvent"]>,
      required: true
    },
    selectedCompany: {
      type: Object as PropType<Props["selectedCompany"]>,
      required: true
    },
    speechBubble: {
      type: Object as PropType<Props["speechBubble"]>,
      required: true
    }
  },
  computed: {
    isPlanGraduateYear() {
      if (!this.selectedEvent || !this.planGraduateYear) return;
      return this.planGraduateYear === this.selectedEvent.graduate_year;
    },
    hasEventExperiencesPage() {
      let result = false;
      if (!this.selectedEvent) {
        return result;
      }
      if (this.isPlanGraduateYear) {
        result = true;
        return result;
      }
      // NOTE: 体験談詳細ページが表示できる場合のみ「詳細」ボタンを表示する
      const { category, purpose } = this.selectedEvent;
      if (
        purpose === EventPurpose.Intern ||
        purpose === EventPurpose.Recruitment
      ) {
        result = [
          EventCategory.Empty,
          EventCategory.Event,
          EventCategory.GroupDiscussion,
          EventCategory.Recruiter,
          EventCategory.JobSelection,
          EventCategory.ObInterview,
          EventCategory.Prehire,
          EventCategory.Interview,
          EventCategory.WebExamination,
          EventCategory.PaperExamination
        ].includes(category);
      }
      return result;
    }
  },
  mounted() {
    window.addEventListener("keyup", this.handleKeyup);
  },
  methods: {
    getBMELabel(bme) {
      switch (bme) {
        case BME_PART.BEGINNING:
          return "上旬";
        case BME_PART.MIDDLE:
          return "中旬";
        case BME_PART.END:
          return "下旬";
      }
      return "";
    },
    handleKeyup(event) {
      if (event.keyCode !== KEYCODE.ESC) {
        return;
      }
      this.$emit("keyupEsc");
    },
    handleDetailClick() {
      if (!this.selectedEvent) {
        return;
      }
      if (this.isPlanGraduateYear) {
        window.open(
          `/event-details/${this.selectedEvent.event_detail_id}`,
          "_blank",
          "noopener"
        );
      } else {
        const pageUrl = this.$router.resolve({ name: "EventExperiences" }).href;

        const formattedStartAt = this.formatBMEPeriod(
          this.selectedEvent.start_at
        );
        const formattedEndAt = this.formatBMEPeriod(this.selectedEvent.end_at);

        const eventCategory = encodeURIComponent(this.selectedEvent.category);
        const eventPurpose = encodeURIComponent(this.selectedEvent.purpose);

        const pageUrlWithQueries = [
          pageUrl,
          "?cid=" + this.selectedCompany!.id,
          "&gy=" + this.selectedEvent.graduate_year,
          "&p=" + eventPurpose,
          "&c=" + eventCategory,
          "&s=" + formattedStartAt,
          "&e=" + formattedEndAt
        ].join("");

        window.open(pageUrlWithQueries, "_blank", "noopener");
      }
    },
    formatBMEPeriod(BMEPeriod) {
      const { type, part, year, month, day } = BMEPeriod;

      return [
        type === "BME" ? 1 : 2,
        part,
        ("0000" + year).slice(-4),
        ("00" + month).slice(-2),
        ("00" + (day || "00")).slice(-2)
      ].join("");
    }
  }
});
